"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printDeprecationWarning = exports.printComponentDeprecationWarning = exports.printPropDeprecationWarning = void 0;

var _warning = _interopRequireDefault(require("warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Util to generate a standardized deprecation message. Takes
 * an options object as input and returns a string.
 *
 * @param {String} options.componentName name of the component
 * @param {String} options.version since being deprecated
 * @param {String} options.deprecated prop that's been deprecated
 * @param {String} options.migration message to what to migrate to
 */
var propDeprecationMessage = function propDeprecationMessage(_ref) {
  var componentName = _ref.componentName,
      version = _ref.version,
      deprecated = _ref.deprecated,
      migration = _ref.migration;
  return "".concat(componentName, " v").concat(version, "+ has deprecated the ").concat(deprecated, " prop. ").concat(migration, " See the CHANGELOG.md for details.");
};
/**
 * console.error if prop is deprecated. Takes
 * an Array of props to deprecate and a migration
 * message. Handles current props and nextProps.
 *
 * The shape of the deprecated props are:
 *
 * {
 *  version: '1.0',
 *  deprecated: 'propName',
 *  migration: 'You should be using prop X instead"
 * }
 *
 * @param {String} componentName name of the component
 * @param {Array} deprecatedProps collection of props to deprecate. See above for shape
 * @param {Object} currentProps props to check for deprecation
 */


var printPropDeprecationWarning = function printPropDeprecationWarning(componentName, deprecatedProps, currentProps) {
  if (!deprecatedProps || deprecatedProps.length === 0) {
    throw new Error('an array of deprecated props must be supplied to the deprecate util.');
  }

  deprecatedProps.forEach(function (prop) {
    var deprecated = prop.deprecated,
        migration = prop.migration,
        version = prop.version;
    (0, _warning.default)(currentProps && !currentProps[deprecated], propDeprecationMessage({
      componentName: componentName,
      version: version,
      deprecated: deprecated,
      migration: migration
    }));
  });
};
/**
 * console.error if component is deprecated or
 * deprecated props have been used in the component.
 * Handles current props and nextProps.
 *
 * Util to generate a standardized deprecation message. Takes
 * an options object as input and returns a string.
 *
 * @param {String} options.component name of the component
 * @param {String} options.version since being deprecated
 * @param {String} options.migration message to what to migrate to
 */


exports.printPropDeprecationWarning = printPropDeprecationWarning;

var printComponentDeprecationWarning = function printComponentDeprecationWarning(_ref2) {
  var component = _ref2.component,
      version = _ref2.version,
      migration = _ref2.migration;

  if (!component) {
    throw new Error('component must be supplied to the deprecate util.');
  }

  (0, _warning.default)(false, "".concat(component, " v").concat(version, "+ has been deprecated. ").concat(migration, " See the CHANGELOG.md for details."));
};
/**
 * generic deprecation warning that accepts any message
 * @param {String} options.message message to output
 */


exports.printComponentDeprecationWarning = printComponentDeprecationWarning;

var printDeprecationWarning = function printDeprecationWarning(_ref3) {
  var message = _ref3.message;
  (0, _warning.default)(false, message);
};

exports.printDeprecationWarning = printDeprecationWarning;